import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/comunicados';
import ComunicadosList from './Comunicados';

const ms2p = (state) => {
    return {
        ...state.comunicados,
    };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(ComunicadosList);
